/* src/app/shared/components/recaptcha/recaptcha.component.css */
#recaptcha-container {
  margin: 20px;
}
/*# sourceMappingURL=recaptcha.component-2NSM4YMH.css.map */
